// extracted by mini-css-extract-plugin
module.exports =  {"wells":"jZEkaWJQLuJ8zElxe60H"};